import { ID } from 'appwrite';

import { RegisterUserInfoType, UserInfoType } from '../../types';
import { account } from '../../utils/appwriteConfig';

export const loginUser = async (userInfo: UserInfoType) => {
  await account.createEmailPasswordSession(userInfo.email, userInfo.password);
  const accountDetails = await account.get();
  return accountDetails;
};

export const registerUser = async (userInfo: RegisterUserInfoType) => {
  await account.create(
    ID.unique(),
    userInfo.email,
    userInfo.password,
    userInfo.name
  );

  await account.createEmailPasswordSession(userInfo.email, userInfo.password);
  const accountDetails = await account.get();

  return accountDetails;
};

export const checkUserStatus = async () => {
  const accountDetails = await account.get();
  return accountDetails;
};

export const logoutUser = async () => {
  const accountDetails = await account.deleteSession('current');
  return accountDetails;
};
